module.exports = __webpack_public_path__ + "static/media/orbit.gif";